import STATUS_TYPES from './status/types';

export default {
  ...STATUS_TYPES,
};
